import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getGroupInfo, getGroupInfoLeadre } from "../../api/group";
import DashboardGroup from "../../components/dashboardGroup";
import NotePage from "./notePage";

export default function DashboardTrip({ data }) {
  const [selected, setSelected] = useState(0);
  const [dataGroup, setDataGroup] = useState();
  useEffect(() => {
    getGroupInfoLeadre()
      .then((x) => setDataGroup(x))
      .catch(() => {});
  }, []);
  return (
    <>
      <Box display="flex" mt="40px" gap="20px">
        <Typography
          onClick={() => setSelected(0)}
          className={
            selected === 0 ? "styleSelectedTab" : "styleNotSelectedTab"
          }
        >
          {"داشبورد"}
        </Typography>
        <Typography
          onClick={() => setSelected(1)}
          className={
            selected === 1 ? "styleSelectedTab" : "styleNotSelectedTab"
          }
        >
          {"یادداشت"}
        </Typography>
      </Box>
      {selected === 0 && <DashboardGroup leader data={dataGroup} />}
      {selected === 1 && <NotePage />}
    </>
  );
}
